<template>
  <div class="card">
    <div
      v-if="image && image.imageUri"
      class="card-image"
      :class="{square: image.size === 'square'}"
    >
      <img :src="image.imageUri" :alt="image.accessibilityText" />
    </div>
    <div class="card-content">
      <div class="card-title" v-if="title">{{ title }}</div>
      <div class="card-subtitle" v-if="subtitle">{{ subtitle }}</div>
      <div class="card-text" v-if="text && text.length > 0">
        <pre>{{ text }}</pre>
      </div>

      <div class="card-buttons" v-if="buttons">
        <a
          v-for="button in buttons"
          class="card-button"
          target="_blank"
          rel="noopener noreferrer"
          :href="button.openUriAction.uri"
        >
          <i
            v-if="button.icon && button.icon.split(' ')[0] == 'fab'"
            aria-hidden="true"
            :class="[{ 'card-button-icon': true }, button.icon]"
          ></i>
          <i
            v-else
            aria-hidden="true"
            class="material-icons card-button-icon"
          >{{ button.icon || "arrow_forward" }}</i>
          <span class="card-button-title">{{ button.title }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
@media only screen and (min-width: 601px)
  .card
    background-color: white
    box-shadow: 0 2px 6px 2px rgba(60,64,67,0.15)
    border-radius: 12px
    display: flex
    flex-direction: column
    max-width: 300px
    min-width: 300px
    margin: 8px
    cursor: pointer
  .card-button
    margin-top: 8px
    text-decoration: none
    line-height: 24px
    color: rgb(64, 173, 156)
    border: 1px solid rgb(64, 173, 156)
    border-radius: 40px
    display: block
    font-weight: 500
    padding: 8px 16px
    text-align: center
    position: relative
  .card-button-icon
    left: 0
    margin-left: 12px
    position: absolute
  .card-image
    width: 300px
    padding-bottom: 75%
    height: auto
    position: relative
    object-fit: cover
    border-top-right-radius: 10px
    border-top-left-radius: 10px
    overflow: hidden
  .card-image img
    width: 100%
    height: 100%
    position: absolute
    object-fit: cover
  .card-content
    padding: 1rem 1rem 1rem 1rem
    flex: 1
  .card-title
    font-weight: 500
    font-size: 20px
    color: #202124
    line-height: 24px
    overflow: hidden
    text-overflow: ellipsis
  .card-subtitle
    font-size: 16px
    line-height: 24px
    color: #757575
  .card-text
    line-height: 24px
    font-size: 16px
    color: #757575
    white-space: normal
  .card-buttons
    padding-top: 8px
    margin-bottom: 0
    align-self: flex-end
@media only screen and (max-width: 600px)
  .card
    background-color: white
    box-shadow: 0 2px 6px 2px rgba(60,64,67,0.15)
    border-radius: 12px
    display: flex
    flex-direction: column
    max-width: 175px
    min-width: 175px
    min-height: fit-content
    margin: 8px
    cursor: pointer
  
  .card-button
    margin-top: 6px
    text-decoration: none
    line-height: 14px
    color: rgb(64, 173, 156)
    border: 1px solid rgb(64, 173, 156)
    border-radius: 40px
    display: block
    font-weight: 500
    font-size: 9px
    padding: 4px 16px
    text-align: center
    position: relative
    
  .card-button-icon
    left: 0
    margin-top: 4px
    margin-left: 12px
    position: absolute
    font-size: 0
  .card-image
    width: 175px
    padding-bottom: 55%
    position: relative
    object-fit: cover
    border-top-right-radius: 10px
    border-top-left-radius: 10px
    overflow: hidden
  .card-image img
    width: 100%
    position: absolute
    object-fit: cover
  .card-content
    padding: 0 1rem 0.5rem 1rem
    flex: 1
  .card-title
    font-weight: 500
    font-size: 12px
    color: #202124
    line-height: 18px
    overflow: hidden
    text-overflow: ellipsis
  .card-subtitle
    font-size: 9px
    line-height: 18px
    color: #757575
  
  .card-text
    line-height: 18px
    font-size: 9px
    color: #5F6368
    white-space: normal
  .card-buttons
    padding-top: 0
    margin-bottom: 0
    align-self: flex-end
.card-image.square
  height: 100px
  padding-bottom: 0
.card-content-buttons
  padding: 0 1rem 1rem 1rem
.card-text pre
  white-space: pre-wrap
  word-wrap: break-word
  font-family: inherit
  margin: 0
</style>

<script>
export default {
  name: "Card",
  props: ["title", "subtitle", "text", "image", "buttons"]
};
</script>
